import React from 'react';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="min-h-screen flex flex-col" data-id="element-195">{children}</div>;
};